export const AuthActionTypes = {
    LOGIN: 'LOGIN',
    GET_AUTHORIZE_TOKEN: 'GET_AUTHORIZE_TOKEN',
    SET_REGISTER: 'SET_REGISTER',
    LOGOUT: 'LOGOUT',
    GET_PUBLIC_TOKEN: 'GET_PUBLIC_TOKEN',
    SET_GLOBAL_LOADING: 'SET_GLOBAL_LOADING',

    // register section
    GET_COUNTRIES: 'GET_COUNTRIES',
    GET_STATES: 'GET_STATES',
    GET_CITIES: 'GET_CITIES',
    CLEAR_REGROUND: 'CLEAR_REGROUND',
    // create-profile-step-2
    // PR
    GET_PR_COUNTRIES: 'GET_PR_COUNTRIES',
    GET_PR_STATES: 'GET_PR_STATES',
    GET_PR_CITIES: 'GET_PR_CITIES',
    // POB
    GET_POB_COUNTRIES: 'GET_POB_COUNTRIES',
    GET_POB_STATES: 'GET_POB_STATES',
    GET_POB_CITIES: 'GET_POB_CITIES',
    // Dynamic reground
    GET_DYNAMIC_PR_COUNTRIES: 'GET_DYNAMIC_PR_COUNTRIES',
    GET_DYNAMIC_PR_STATES: 'GET_DYNAMIC_PR_STATES',
    GET_DYNAMIC_PR_CITIES: 'GET_DYNAMIC_PR_CITIES',

    // profile section
    UPDATE_PROFILE: 'UPDATE_PROFILE',
}
